import { Suspense } from "react";
import GlobalWaitIndicator from "./GlobalWaitIndicator";

export default function EstadaSuspense(props: { Component?: any; props?: any }) {
  const { Component } = props;
  if (!Component) {
    return <div></div>;
  }
  return (
    <Suspense fallback={<Loading />}>
      <Component {...props.props} />
    </Suspense>
  );
}

export function Loading(props: { text?: string }) {
  const { text } = props;

  return <GlobalWaitIndicator text={text} visible={true} />;
}
